import React from 'react';
import Questionnaires from './Questionnaires';
import { Route, Switch } from 'react-router-dom';
import Questionnaire from './medixine/Questionnaire';
import CareRequest from './medixine/CareRequest';
import AivaDiagrams from './AivaDiagrams';
import AssignedCareRequest from './medixine/AssignedCareRequest';
import CoronaQuestionnaire from './medixine/CoronaQuestionnaire';
import FormResponse from '../form/FormResponse';
import FormDataViewer from '../form/FormDataViewer';
import { getFrontendProperties } from '../../definitions/Config';
import FormulaContextProvider from '../../context/FormulaContext';
import { SnackbarProvider } from 'notistack';

class QuestionnaireRouter extends React.Component {
  render() {
    let { match } = this.props;

    return (
      <FormulaContextProvider
        formulaUrl={getFrontendProperties().questionnaireFormulaUrl}
      >
        <Switch>
          <Route
            path={`${match.path}/aiva/:aivaProcessId`}
            component={AivaDiagrams}
          />
          <Route path="/questionnaires" exact component={Questionnaires} />
          <Route
            path={`${match.path}/edit/:formOID/:patientOID/:answerOID`}
            component={Questionnaire}
          />
          <Route
            path={`${match.path}/response/:formId/:formResponseId?/:reviewForm?`}
          >
            <SnackbarProvider>
              <FormResponse />
            </SnackbarProvider>
          </Route>
          <Route path={`${match.path}/view/:assignmentId`}>
            <FormDataViewer />
          </Route>
          <Route
            path={`${match.path}/fill/:formId/:formResponseId?/:reviewForm?`}
          >
            <SnackbarProvider>
              <FormResponse status={'DRAFT'} />
            </SnackbarProvider>
          </Route>
          <Route
            path={`${match.path}/covid19`}
            component={CoronaQuestionnaire}
          />
          <Route
            path={`${match.path}/new/:formOID/:careEventOID?`}
            component={CareRequest}
          />
          <Route
            path={`${match.path}/assign/:systemName/:appointmentId`}
            component={AssignedCareRequest}
          />
        </Switch>
      </FormulaContextProvider>
    );
  }
}

export default QuestionnaireRouter;
